// Reads the `exp` claim out of a JWT without verifying its signature — the
// client only uses this to schedule a proactive refresh, the server is the
// actual authority on validity. Returns null on any malformed input rather
// than throwing, since this is purely a background-refresh optimization.
export function decodeJwtExpMs(token: string): number | null {
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const json = atob(base64)
    const decoded = JSON.parse(json) as { exp?: number }
    return typeof decoded.exp === 'number' ? decoded.exp * 1000 : null
  } catch {
    return null
  }
}
